import { api, EnumerationValue, ResourcePage, responseErrorCheck, TmrBaseResource } from 'stylewhere/api'

export class EnumerationValues extends TmrBaseResource {
  static endpoint = 'api/v1/enumerationvalues' //profile

  static getByEnumerationTypeId(enumerationTypeId: string): Promise<ResourcePage<EnumerationValue>> {
    return api
      .get<ResourcePage<EnumerationValue>>(`${this.endpoint}?enumerationTypeIds=${enumerationTypeId}`)
      .then(responseErrorCheck)
  }
}
